import React, {useEffect, useState} from "react";
import {DUTCHIE, METRC, getMetrcStripeIds, getDutchieStripeIds} from "../../../constants";
import {isEmpty, setCookie} from "weed-js";
import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
} from "@mui/material";


const useResponsiveOrientation = () => {

    const slimScreen = () => {
        return window.innerWidth < 900;
    };

    const shortScreen = () => {
        return window.innerHeight < 800;
    };

    const isMobile = () => {
        return window.innerWidth <= 768 || window.innerHeight <= 768;
    }

    const getOrientation = () => ({
        isVertical: slimScreen() || shortScreen(),
        isMobile: isMobile()
    });

    const [orientation, setOrientation] = useState(getOrientation());

    useEffect(() => {
        const handleResize = () => {
            setOrientation(getOrientation());
        };

        window.addEventListener("resize", handleResize);

        // Clean up the event listener on component unmount
        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    return orientation;
}


const AccordionWhenSmall = ({title, subtitle, content, orientation}) => {
    return <div className={"create-account-choose-integration-accordion"}>
        <h3>{title}</h3>
        <h4>{subtitle}</h4>
        {content.map((item, index) => (
            <p key={`${title}-${index}`}>{item}</p>
        ))}
    </div>
}


export const ChooseAnIntegration = ({formState, setFormState}) => {
    const orientation = useResponsiveOrientation();

    return <div className={"create-account-choose-a-integration-container"}>
        <h2>Choose Your First Integration</h2>
        <div className={"create-account-choose-integration-subcontainer"}>
            <div className={"create-account-choose-integration choose-analytics-monthly" + (formState.integration === DUTCHIE ? " selected" : "")}
                onClick={() => {
                    setCookie("integration", DUTCHIE); // Set cookie for 30 days
                    setFormState({
                        ...formState,
                        integration: DUTCHIE,
                        ...getDutchieStripeIds(),
                    });
                }}
            >
                <div className={"create-account-choose-integration-icon-container"}>
                    <img
                        src={`${process.env.REACT_APP_PUBLIC_URI}/dutchie.svg`}
                        alt="Dutchie"
                        id={"choose-dutchie-integration"}
                        className={"create-account-choose-integration-icon" + (formState.integration === DUTCHIE ? " selected" : "")}
                    />
                </div>
                <AccordionWhenSmall
                    title="Dutchie"
                    subtitle="(No Additional Usage Costs)"
                    content={[
                        "With our Dutchie Integration you get access to robust retail data and key models to ensure your store(s) are running at peak efficiency."
                    ]}
                    orientation={orientation}
                />
            </div>
            <div className={"create-account-choose-integration choose-premium" + (formState.integration === METRC ? " selected" : "")}
                onClick={() => {
                    setCookie("integration", METRC); // Set cookie for 30 days
                    setFormState({
                        ...formState,
                        integration: METRC,
                        ...getMetrcStripeIds(),
                    });
                }}
            >
                <div className={"create-account-choose-integration-icon-container"}>
                    <img
                        id={"choose-metrc-integration"}
                        src={`${process.env.REACT_APP_PUBLIC_URI}/metrc.png`}
                        alt="Metrc"
                        className={"create-account-choose-integration-icon" + (formState.integration === METRC ? " selected" : "")}
                    />
                </div>
                <AccordionWhenSmall
                    title="Metrc"
                    subtitle="(Usage Costs Typically Range from $0.20-1.50 per Day per Store)"
                    content={[
                        "With our Metrc Integration we offer the same analytics as Dutchie, but we enable configurable API quotas to keep your costs predictable.",
                        "Pay no more in additional costs than what you use. NOTE: We do not sync metrc data automatically without your permission, but you can trigger a sync at any time and set quotas to manage budget."
                    ]}
                    orientation={orientation}
                />
            </div>
        </div>
    </div>;
};


export default ChooseAnIntegration;
